<div class="user-account">
    @if (breakpointService.isMobile() && userAccountService.showUserMobileSwitcher$ | async) {
        <div class="user-account__mobile-header">
            <app-switcher
                    [isDynamicWidth]="true"
                    [selectedIndex]="pageIndex"
                    [switcherConfig]="[
                          { label: 'Wishlist', parameter: eRoutes.MY_TRIPS, info: {type: 'hurt', count: favoritesProviderService.storedFavourites.length} },
                          { label: 'Saved Trips', parameter: eRoutes.SAVED_TRIPS, info: {type: 'circle', count: (tripsService.savedTripsCount$ | async)} },
                          { label: 'Personal settings', parameter: eRoutes.SETTINGS },
                        ]"
                    (selectedSwitch)="changeTab($event)">
            </app-switcher>
        </div>
    }
    <router-outlet></router-outlet>
</div>
